import React from "react";
import i18n from "i18next";
import { WEB_LANGUAGES } from "../utils/Constants";
import { setLocalKey } from "../utils/commonfunction";

export const changePortalLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLocalKey("system_language", lng);
    window.location.reload();
};

const LanguageSwitcherItems = () => (
    <>
        {WEB_LANGUAGES.map((lang) => (
            <li key={lang.code}>
                <button
                    type="button"
                    onClick={() => changePortalLanguage(lang.code)}
                    className="dropdown-item"
                >
                    {lang.name}
                </button>
            </li>
        ))}
    </>
);

export default LanguageSwitcherItems;
